import React, { Component } from 'react';
import { Modal } from 'antd';


import './Recipient.css';


export default class Message extends Component {

  static propTypes = {
    data: React.PropTypes.object,
    profile: React.PropTypes.object,
    displayEmail: React.PropTypes.bool,
    loadProfile: React.PropTypes.func
  };

  state = {
    data: this.props.data,
    profile: this.props.profile,
    showModal: false
  };

  componentWillMount() {
    this.props.loadProfile();
  }

  toggleModal = () => {
    // this.setState(state => ({ showModal: !state.showModal }));
  };

  componentWillReceiveProps(nextProps) {
    this.setState({ ...nextProps });
  }

  render() {
    const { email, name } = this.state.data;
    const { profile } = this.state;
    return (
      <div >
        <span className="participant" onClick={ ::this.toggleModal } >

          { this.props.displayEmail ? <span >Send message to: { email }</span > :
            <span >Send message to: { name }</span > }
        </span >
        <Modal
          visible={ this.state.showModal }
          footer={ null }
          onCancel={ ::this.toggleModal }
          closable={ false }
        >
          { profile ? <div className="participant" >
            <div >name: { profile.user.name }</div >
            {
              this.props.displayEmail &&
              < div >email: { profile.user.email }</div >
            }
            {
              profile.profile ? <div >
                <div >gender: { profile.profile.gender }</div >
                <div >birth date: { profile.profile.birthDate }</div >
                <div >birth time: { profile.profile.birthTime }</div >
                <div >birth country: { profile.profile.birthCountry }</div >
                <div >birth state/city: { profile.profile.birthStateCity }</div >
              </div > : null
            }
          </div > : null
          }
        </Modal >
      </div >
    );
  }
}



// WEBPACK FOOTER //
// ./src/elements/recipient/Recipient.jsx